/**
 * Выброс мёртвой сессии.
 *
 * ⚠️ СЕРВЕР ОТКАЗЫВАЛ, А КЛИЕНТ НЕ СЛУШАЛ. Каждая ручка данных проверяет ключ
 * по базе и на негодный отвечает 401 — учётную запись удалили, ключ подделан
 * или протух. Во вьюере же 401 не разбирался НИГДЕ: ни одной проверки статуса
 * на весь проект. Игра от этого не падала, и потому беда была тихой: садок не
 * открывается, кошелёк не считается, улов не записывается, — а человек сидит
 * на берегу, забрасывает и не понимает, почему рыба не идёт в зачёт.
 *
 * ⚠️ ДЕЛАЕМ РОВНО ТО ЖЕ, ЧТО КНОПКА «ВЫЙТИ». Она чистит два ключа и
 * перезагружает страницу (main.ts, hooks.logout). Свой, «более мягкий» путь —
 * показать окно, спросить, увести в лобби — означал бы второй способ выйти из
 * игры, а он неминуемо разойдётся с первым: там почистили, тут забыли.
 *
 * ⚠️ ВХОД И РЕГИСТРАЦИЯ СЮДА НЕ ХОДЯТ. У них 401 значит «неверный пароль», и
 * перезагружать страницу в ответ на опечатку было бы издевательством. Поэтому
 * проверка стоит только в обёртках над ручками ДАННЫХ, а net/login.ts со
 * своими тремя запросами разбирается сам.
 */

/**
 * Выброшены ли уже.
 *
 * ⚠️ БЕЗ ЭТОГО ПЕРЕЗАГРУЗОК БУДЕТ ПЯТЬ. Лобби спрашивает кошелёк, садок,
 * снаряжение, рекорды и свои уловы разом, пятью запросами без ожидания друг
 * друга. Умерла сессия — откажут все пять, и каждый позовёт reload.
 */
let выброшены = false;

/**
 * Выбросить: стереть ключи и перезагрузиться на форму входа.
 *
 * ⚠️ ЗВАТЬ ТОЛЬКО ТОГДА, КОГДА СЕССИЯ ТОЧНО МЕРТВА. Обычный отказ сервера —
 * не хватило монет, имя занято — сюда не относится: перезагрузка стёрла бы
 * несохранённое ради ошибки, которую достаточно показать строкой.
 *
 * ⚠️ ФОРМУ ПОКАЗЫВАТЬ НЕ НАДО. После перезагрузки boot.ts не находит ключа и
 * поднимает форму сам. Свой показ #auth-container поверх живой игры уже есть
 * в net/auth-flow.ts — и это как раз то, чего делать нельзя: сцена, сокет и
 * инвентарь остаются на месте, а поверх них лежит форма входа.
 */
export function выброситьМёртвуюСессию(): void {
  if (выброшены) return;
  выброшены = true;
  localStorage.removeItem('if-auth-token');
  localStorage.removeItem('if-auth-email');
  window.location.reload();
}

/**
 * Проверить ответ. `true` — сессия мертва, дальше делать нечего.
 *
 * Зовётся из обёрток сразу после fetch, ДО разбора тела: у отказа тела может
 * не быть вовсе.
 *
 * ⚠️ РОВНО 401 И НИЧЕГО БОЛЬШЕ. У лобби записано правило: ни один отказ не
 * гасит экран, вместо числа встаёт прочерк. Расширь проверку до «любой 4xx» —
 * и упавшая ручка выкидывала бы человека из игры вместо прочерка в строке.
 */
export function сессияМертва(res: Response): boolean {
  if (res.status !== 401) return false;
  выброситьМёртвуюСессию();
  return true;
}
